import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("awb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const code = err.response?.data?.code;
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("awb_token");
      // Soft redirect to login
      if (!window.location.pathname.startsWith("/reset") && !window.location.pathname.startsWith("/forgot")) {
        window.location.href = "/login";
      }
    }
    if (code === "SUSPENDED") window.location.href = "/account-suspended";
    if (code === "EXPIRED") window.location.href = "/subscription-expired";
    return Promise.reject(err);
  }
);

export async function downloadFile(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// Guarantees an array is returned so .filter()/.map() calls never crash
// with "x.filter is not a function" when the API returns something
// unexpected (null, undefined, an object, etc.) — e.g. during backend
// errors, empty responses, or shape mismatches.
export function arr(value) {
  return Array.isArray(value) ? value : [];
}

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.message || err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default api;
